<template>
  <div class="objectives" id="info">
    <b-card-group deck>
      <div v-for="dset_type in dset_types" :key="dset_type.id">
        <property
          :dset_type="dset_type"
          :group_property="property_details[dset_type]"
          :search_button="search_button"
        />
      </div>
    </b-card-group>
  </div>
</template>

<script>
import Property from "@/components/Property.vue";

export default {
  name: "TMLSummary",
  props: {
    property_details: Object,
    dset_types: Array,
    search_button: Boolean,
  },
  components: {
    Property,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 !important;
}
</style>
